import { render, staticRenderFns } from "./VCol.vue?vue&type=template&id=4019e680&scoped=true&"
import script from "./VCol.vue?vue&type=script&lang=js&"
export * from "./VCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4019e680",
  null
  
)

component.options.__file = "VCol.vue"
export default component.exports